module.exports = __webpack_public_path__ + "static/media/pencil.8aac0509.svg";